import create from 'zustand';
import store from './quickEntry.vanilla.store';

const useStore = create(store);

export default useStore;
